import ClientPage from './ClientPage';

export default ClientPage;
